
import d from './d_api'
import g from './g_api'

export const sss = 1
export default {
  ...d,
  ...g
}


